import React, { Suspense, lazy } from 'react'
import { Spinner } from '@mobi/component-library/Legacy/Spinner'
import { useAuthenticatedAccount } from '@core/Components/RequireAuth/hooks'
import { UpdateAccountBalance } from '@core/State/UserAccount/userAccountDriver'
import { fullClientVersion } from '@core/Utils/clientVersion'
import { trackWithdrawalPercentage } from './analytics'

const App = lazy(() => import('@mobi/account/Areas/Withdraw/Components/App'))

export const WithdrawPage = (): JSX.Element | null => {
  const { accountNumber } = useAuthenticatedAccount()

  return (
    <Suspense fallback={<Spinner />}>
      <App
        betAccountNumber={accountNumber}
        onWithdrawSuccess={withdrawResponse => {
          trackWithdrawalPercentage(withdrawResponse)
          UpdateAccountBalance({ balance: withdrawResponse.balance })
        }}
        appVersion={fullClientVersion}
      />
    </Suspense>
  )
}
